import { render, staticRenderFns } from "./StockList.vue?vue&type=template&id=1f34219e&scoped=true&"
import script from "./StockList.vue?vue&type=script&lang=js&"
export * from "./StockList.vue?vue&type=script&lang=js&"
import style0 from "./StockList.vue?vue&type=style&index=0&id=1f34219e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f34219e",
  null
  
)

export default component.exports